// these can be replaced with CD colors once they're available

export var chartColors = {
  AMBER: {
    14: '#EE8846'
  },
  BLUE: {
    5: '#00368A',
    6: '#003DA1',
    8: '#034FCA',
    10: '#1E6DEB',
    12: '#3883FA',
    14: '#69A2FE',
    15: '#83B2FE',
    16: '#9BC1FE',
    18: '#C8DCFE',
    20: '#E6EFFE',
    21: '#F5F8FF'
  },
  GRAY: {
    5: '#363B51',
    10: '#616D92',
    15: '#83B2FE',
    18: '#D8DBE9',
    19: '#E3E6F2',
    20: '#A9B1CC',
    21: '#F6F8FE'
  },
  GREEN: {
    13: '16A68C'
  },
  VIOLET: {
    12: '#BB5FEC'
  }
};